/* eslint-disable no-param-reassign */
import { useMemo } from 'react';
import { types } from 'mobx-state-tree';
import type {
  Instance,
  SnapshotIn,
  SnapshotOut,
} from 'mobx-state-tree/dist/core/type/type';

import { UserModel } from '@/models/users';
import { initializeStore } from '@/stores';
import type { StudentProfileModelType, UserModelType } from '@/models/users';

export const UserStore = types
  .model({
    me: types.maybe(UserModel),
  })
  .actions((self) => ({
    setMe(me: UserModelType) {
      self.me = me;
    },
    updateStudentProfile(studentProfile: StudentProfileModelType) {
      if (!self.me) {
        return;
      }

      self.me.studentprofile = studentProfile;
      self.me.photo = studentProfile.user?.photo;
    },
  }))
  .named('UserStore');

export const useUserStore = (
  initialState: UserStoreSnapshotIn | null = null,
): UserStoreType => {
  return useMemo(
    () => initializeStore(UserStore, initialState),
    [initialState],
  );
};

export type UserStoreType = Instance<typeof UserStore> & {};

export type UserStoreSnapshotIn = SnapshotIn<typeof UserStore> & {};

export type UserStoreSnapshotOut = SnapshotOut<typeof UserStore> & {};
